export const convertIdToName = (array, id) => {
  let name = null
  array.forEach((d) => {
    if (d._id === id) {
      name = d.name
    }
  })
  return name
}
